(function () {
  'use strict';

  var NATIVE_VARIANT_EVENTS = [
    'variant:changed',
    'variant:change',
    'variant:updated',
    'product:variant:changed'
  ];

  var JQUERY_VARIANT_EVENTS = NATIVE_VARIANT_EVENTS.concat([
    'variant:select',
    'variant:change.t4s'
  ]);

  function getJq() {
    return window.jQuery_T4NT || window.jQuery || null;
  }

  function parseVariantIds(value) {
    if (!value) return [];
    return value.replace(/\uFF0C/g, ',').split(',').map(function (id) {
      return id.trim();
    }).filter(Boolean);
  }

  function resizeFlickityInSection(section) {
    var slider = section.querySelector('.flickityt4s-enabled');
    if (!slider) return;

    var $ = getJq();
    if (!$ || !$(slider).data('flickityt4s')) return;

    try {
      $(slider).flickityt4s('resize');
    } catch (e) {
      // ignore
    }
  }

  function setSectionVisibility(section, variantId) {
    var allowed = parseVariantIds(section.getAttribute('data-variant-filter'));
    if (!allowed.length) return;

    var visible = allowed.indexOf(String(variantId)) !== -1;
    var root = section.closest('.shopify-section');

    section.hidden = !visible;
    if (root) root.hidden = !visible;

    if (visible) resizeFlickityInSection(section);
  }

  function applyAll(variantId) {
    if (!variantId) return;

    document.querySelectorAll('[data-variant-filter]').forEach(function (section) {
      setSectionVisibility(section, variantId);
    });
  }

  function getCurrentVariantId() {
    var input = document.querySelector('[data-product-featured] [name="id"], form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;

    if (window.current_variant && window.current_variant.id) return String(window.current_variant.id);
    if (window.variant && window.variant.id) return String(window.variant.id);
    if (window.initial_variant && window.initial_variant.id) return String(window.initial_variant.id);

    var prodEl = document.querySelector('[data-product]');
    if (prodEl && prodEl.getAttribute('data-current-variant-id')) {
      return prodEl.getAttribute('data-current-variant-id');
    }

    try {
      var params = new URLSearchParams(window.location.search);
      if (params.has('variant')) return params.get('variant');
    } catch (e) {
      // ignore
    }

    return null;
  }

  function syncHiddenSectionRoots() {
    document.querySelectorAll('[data-variant-filter][hidden]').forEach(function (section) {
      var root = section.closest('.shopify-section');
      if (root) root.hidden = true;
    });
  }

  function extractVariantIdFromEvent(detailVariantId, eventObj) {
    if (detailVariantId) {
      if (typeof detailVariantId === 'object' && detailVariantId.id) {
        return String(detailVariantId.id);
      }
      return String(detailVariantId);
    }

    if (!eventObj) return null;

    if (eventObj.detail) {
      var d = eventObj.detail;
      if (d && (d.variant || d.currentVariant || d.selectedVariant)) {
        var v = d.variant || d.currentVariant || d.selectedVariant;
        return v && v.id ? String(v.id) : null;
      }
      if (d && d.id) return String(d.id);
    }

    // jQuery .trigger({ type, currentVariant, ... })
    if (eventObj.currentVariant && eventObj.currentVariant.id) {
      return String(eventObj.currentVariant.id);
    }
    if (eventObj.variant && eventObj.variant.id) return String(eventObj.variant.id);
    if (eventObj.selectedVariant && eventObj.selectedVariant.id) {
      return String(eventObj.selectedVariant.id);
    }
    if (eventObj.id) return String(eventObj.id);

    return null;
  }

  function handleVariantChangeEvent(detailVariantId, eventObj) {
    var id = extractVariantIdFromEvent(detailVariantId, eventObj) || getCurrentVariantId();
    if (id) applyAll(id);
  }

  function isVariantIdInput(el) {
    if (!el || el.name !== 'id') return false;
    return !!(el.closest('[data-product-featured]') || el.closest('form[action*="/cart/add"]'));
  }

  function observeVariantInput() {
    var input = document.querySelector('[data-product-featured] [name="id"], form[action*="/cart/add"] [name="id"]');
    if (!input) return;

    var lastVal = input.value;
    var mo = new MutationObserver(function () {
      if (input.value !== lastVal) {
        lastVal = input.value;
        applyAll(lastVal);
      }
    });

    try {
      mo.observe(input, { attributes: true, attributeFilter: ['value'] });
    } catch (e) {
      var t = window.setInterval(function () {
        if (!input) {
          window.clearInterval(t);
          return;
        }
        if (input.value !== lastVal) {
          lastVal = input.value;
          applyAll(lastVal);
        }
      }, 250);
    }
  }

  function bindNativeVariantEvents() {
    NATIVE_VARIANT_EVENTS.forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        handleVariantChangeEvent(null, e);
      });
    });

    document.addEventListener('change', function (e) {
      if (!isVariantIdInput(e.target)) return;
      applyAll(e.target.value);
    });

    observeVariantInput();
  }

  function bindJqueryVariantEvents() {
    if (window.__variantSectionFilterJqBound) return true;

    var $ = getJq();
    if (!$) return false;

    window.__variantSectionFilterJqBound = true;

    JQUERY_VARIANT_EVENTS.forEach(function (evt) {
      try {
        $(document).on(evt, function (event, variant) {
          handleVariantChangeEvent(variant, event);
        });
      } catch (e) {
        // ignore per-event binding errors
      }
    });

    return true;
  }

  function bindVariantFilter() {
    if (window.__variantSectionFilterBound) return;

    window.__variantSectionFilterBound = true;
    syncHiddenSectionRoots();
    applyAll(getCurrentVariantId());
    bindNativeVariantEvents();
    bindJqueryVariantEvents();
  }

  function tryBindVariantFilter() {
    bindVariantFilter();

    if (bindJqueryVariantEvents()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      if (bindJqueryVariantEvents() || ++attempts >= 50) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryBindVariantFilter);
  } else {
    tryBindVariantFilter();
  }
})();
